import { ConnectionPositionPair, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MegaMenuOverlayRef } from './mega-menu-overlay-ref';

@Directive({
  selector: '[appMegaMenu]',
})
export class MegaMenuDirective implements OnInit, OnDestroy, AfterViewInit {
  private unsubscribe = new Subject();
  private overlayRef!: OverlayRef;
  @Input() appMegaMenu!: TemplateRef<object>;
  @Input() backdropClass = 'mega-menu-backdrop';

  constructor(
    private renderer: Renderer2,
    private host: ElementRef,
    private overlay: Overlay,
    private vcr: ViewContainerRef,
    private megaMenuOverlayRef: MegaMenuOverlayRef
  ) { }

  ngOnInit(): void {
    this.createOverlay();
  }
  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
  ngAfterViewInit(): void { }

  @HostListener('click', ['$event']) onClick(event: any) {
    this.checkOpen();
  }
  @HostListener('touch', ['$event']) onTouch(event: any) {
    this.checkOpen();
  }

  checkOpen() {
    if (this.overlayRef.hasAttached()) {
      this.detachOverlay();
    } else {
      if (this.megaMenuOverlayRef.overlayRef) {
        if (this.megaMenuOverlayRef.overlayRef.hasAttached()) {
          this.megaMenuOverlayRef.overlayRef.detach();
          // // console.log(this.commonOverlayRef.activeElementRef);
          if (this.megaMenuOverlayRef.activeElementRef) {
            this.renderer.removeClass(
              this.megaMenuOverlayRef.activeElementRef.nativeElement,
              'active'
            );
          }
        }
      }
      this.attachOverlay();
    }
  }
  private getOverlayPosition(origin: any) {
    const positions = [
      new ConnectionPositionPair(
        { originX: 'end', originY: 'top' },
        { overlayX: 'start', overlayY: 'top' }
      )
    ];
    return this.overlay
      .position()
      .flexibleConnectedTo(origin)
      .withPositions(positions)
      .withFlexibleDimensions(false)
      .withPush(false);
  }
  private createOverlay(): void {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();
    // const positionStrategy = this.overlay
    //   .position()
    //   .global()
    //   .top('0px')
    //   .left('60px')
    //   .right('0');

    this.overlayRef = this.overlay.create({
      positionStrategy: this.getOverlayPosition(this.host.nativeElement),
      scrollStrategy,
      hasBackdrop: true,
      backdropClass: this.backdropClass,
      panelClass: 'mega-menu',
    });

    this.overlayRef
      .backdropClick()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => {
        this.detachOverlay();
      });
  }

  private attachOverlay(): void {
    if (!this.overlayRef.hasAttached()) {
      const periodSelectorPortal = new TemplatePortal(
        this.appMegaMenu,
        this.vcr
      );

      this.overlayRef.attach(periodSelectorPortal);
      this.megaMenuOverlayRef.activeElementRef = this.host;
      this.renderer.addClass(this.host.nativeElement, 'active');
      this.megaMenuOverlayRef.overlayRef = this.overlayRef;
    }
  }

  private detachOverlay(): void {
    if (this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
      this.renderer.removeClass(this.host.nativeElement, 'active');
    }
  }
}
